import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../../../components/Icon/Icon';
import { createBEM } from '../../../lib/utils/css';

import * as LogoConstants from './constants';

import './Logo.scss';

class Logo extends React.Component {
  static propTypes = {
    isBackgroundDark: PropTypes.bool,
    isBlue: PropTypes.bool,
    tier: PropTypes.string,
    discountType: PropTypes.string,
    isAlwaysStacked: PropTypes.bool,
  };

  static defaultProps = {
    tier: LogoConstants.tiers.AD_SUPPORTED,
    discountType: LogoConstants.discountTypes.NONE,
    isBackgroundDark: false,
    isBlue: false,
    isAlwaysStacked: false,
  };

  getModifierGlyph = () => {
    const { tier, discountType } = this.props;
    if (tier === LogoConstants.tiers.PANDORA_FAMILY) return LogoConstants.ModifierGlyph[tier];

    return discountType && LogoConstants.ModifierGlyph[discountType];
  };

  renderModifierIcon = () => {
    const modifierGlyph = this.getModifierGlyph();
    return (
      modifierGlyph && (
        <React.Fragment>
          <Icon className='Logo__divider' glyph={LogoConstants.RuleIcon} />
          <Icon glyph={modifierGlyph} />
        </React.Fragment>
      )
    );
  };

  renderTierIcon = () => {
    return <Icon glyph={LogoConstants.TierGlyph[this.props.tier]} />;
  };

  render() {
    const { tier, discountType, isBlue, isBackgroundDark, isAlwaysStacked } = this.props;
    const classes = createBEM('Logo', {
      white: !isBlue && isBackgroundDark,
      blue: isBlue,
      stacked: isAlwaysStacked,
    });

    return (
      <div className={classes} aria-label={LogoConstants.planNames[tier][discountType]}>
        {this.renderTierIcon()}
        {this.renderModifierIcon()}
      </div>
    );
  }
}

export default Logo;
